export default __webpack_public_path__ + "static/media/Logo.e1447e79.svg";